import React from 'react';
import '../styles/landing.css';

const Footer = () => {
  return (
    <footer className="footer" id="contact">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Community</h3>
            <p className="align-center">Join our Discord community to:</p>
            <ul>
              <li>• Provide feedback</li>
              <li>• Prep together with others</li>
              <li>• Ask questions</li>
              <li>• Share your progress</li>
            </ul>
            <a href="https://discord.gg/fBcakTEcps" className="discord-link" target="_blank" rel="noreferrer">
              <span>🎮</span> Join Discord
            </a>
          </div>
          
          <div className="footer-section">
            <h3>PrepLetter</h3>
            <p>
              Daily coding interview preparation delivered to your inbox. Master
              DSA patterns with 0 energy and time waste.
            </p>
          </div>

          <div className="footer-section">
            <h3>Contact</h3>
            <p>Questions or suggestions?</p>
            <a href="mailto:hello@rolepilot.ai">Email Us: hello@rolepilot.ai</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} PrepLetter. A Product From RolePilot.AI</p>
          <div className="footer-links">
            <a href="/terms-privacy" className="footer-link">Terms of Use & Privacy Policy</a>
            <span className="footer-separator">•</span>
            <a href="/bug-report?page=general&entity=general" className="footer-link">🐛 Report a Bug</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
